import { IconCurrencyCircleDollar } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import type { OrderValue as OrderValueType } from 'typings'
import { useDrawerState, useFormStateContext } from '../../../..'
import { useConditions } from '../useConditions'
import { Editor } from './Editor'
import { OrderValueView } from './View'
import { messages } from './messages'

interface Props {
  name: string
}

export type OrderValueConfig = OrderValueType | undefined

export function OrderValue(props: Props) {
  const { name } = props
  const { formatMessage: i18n } = useIntl()

  const { form, discountType } = useFormStateContext()
  const config: OrderValueConfig = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: i18n(messages.title),
    icon: <IconCurrencyCircleDollar />,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (values: OrderValueConfig) => form.setValue(name, values)

  return (
    <>
      <OrderValueView
        config={config}
        onEdit={editorState.show}
        onRemove={handleRemove}
      />
      <Editor
        state={editorState}
        initialConfig={config}
        discountType={discountType}
        onSave={handleSave}
      />
    </>
  )
}
